import axios from "axios";
import { API_URL } from "../../constants";
import { getConfig, handleErrors } from "../../utils/utils";
import { CLIENT_ACTIVITY_REPORTS } from "../types";

export const fetchClientActivityReports = () => async (dispatch, getState) => {
  try {
    const res = await axios.get(`${API_URL}/api/reports/client-activity`, {
      ...getConfig(),
    });
    // console.log(res.data);
    localStorage.setItem('clientActivityReports', JSON.stringify(res.data));
    const payload = res.data.data;
    dispatch({ type: CLIENT_ACTIVITY_REPORTS.FETCH_SUCCESS, payload });
  } catch (error) {
    dispatch({ type: CLIENT_ACTIVITY_REPORTS.FETCH_FAILED });

    handleErrors(error);
  }
};
